import { createSignal } from 'solid-js'

const [account, setAccount] = createSignal(window.user ? {
  ...window.user,
  get fixed() {
    return (window.user?.methods ?? []).indexOf('fixed') > -1
  },
  get fan() {
    return (window.user?.methods ?? []).indexOf('fan') > -1
  }
} : {})

export default account

export function logout() {
  setAccount({})
}

export function updateAccount(data) {
  setAccount(e => ({ ...e, ...data }))
}

export function keepalive() {
  if (account().username) {
    fetch('/api/keepalive')
  }
  setTimeout(() => keepalive(), 60_000)
}

export function access(...perms) {
  if (account().permissions === '*') {
    return true
  }
  for (const perm of perms) {
    if (account().permissions.indexOf(perm) === -1) {
      return false
    }
  }
  return true
}
